<!-- EF-3852 — dans la popin (maquette « Popin Onboarding », 1a), colonne « Votre société » : intitulé aligné sur la
     rangée de l'avatar de la colonne « Vous ». -->
@if (embedded()) {
    <div class="profile-company__eyebrow">
        <eb-label
            color="primary"
            size="sm"
            textTransform="uppercase"
            weight="black"
        >
            {{ 'profile.company.your_company' | transloco }}
        </eb-label>
    </div>
} @else {
    <eb-h2 class="profile-company__title">{{ 'profile.my_company' | transloco }}</eb-h2>
}

<form
    class="profile-company__form"
    [formGroup]="form"
>
    <eb-material-input-text
        class="profile-company__street"
        [label]="'profile.company_name' | transloco"
        formControlName="companyName"
        labelPosition="top"
    />

    @if (!embedded()) {
        <div class="profile-company__section">
            <eb-label
                class="profile-company__section-label"
                color="primary"
                size="sm"
                textTransform="uppercase"
                weight="black"
            >
                {{ 'profile.company.postal_address' | transloco }}
            </eb-label>
            <span class="profile-company__section-rule"></span>
        </div>
    }

    <eb-material-input-text
        class="profile-company__street"
        [label]="(embedded() ? 'profile.company.address' : 'profile.company.street') | transloco"
        [placeholder]="embedded() ? ('profile.company.street' | transloco) : ''"
        formControlName="street"
        labelPosition="top"
    />

    <div class="profile-company__grid profile-company__grid--three">
        <eb-material-input-text
            [label]="'profile.company.postal_code' | transloco"
            formControlName="postalCode"
            labelPosition="top"
        />
        <eb-material-input-text
            [label]="'profile.company.city' | transloco"
            formControlName="city"
            labelPosition="top"
        />
        <eb-material-input-select
            [label]="'profile.company.country' | transloco"
            formControlName="country"
            labelPosition="top"
        >
            @for (country of countries; track country.iso2) {
                <eb-material-input-select-option
                    [label]="country.name"
                    [value]="country.iso2"
                />
            }
        </eb-material-input-select>
    </div>
</form>

@if (!embedded()) {
    <div class="profile-company__section">
        <eb-label
            class="profile-company__section-label"
            color="primary"
            size="sm"
            textTransform="uppercase"
            weight="black"
        >
            {{ 'profile.company.logos' | transloco }}
        </eb-label>
        <span class="profile-company__section-rule"></span>
    </div>
}

<div class="profile-company__logos">
    <div class="profile-company__logo profile-company__logo--main">
        <eb-label
            color="flat-secondary"
            size="sm"
            textTransform="uppercase"
            weight="black"
        >
            {{ (embedded() ? 'profile.company.main_logo_short' : 'profile.main_logo') | transloco }}
        </eb-label>
        <div class="mt-2 cursor-pointer">
            <ng-container *ebHasPermissions="[PERMISSIONS.PROFILE_LOGO_MANAGE]; else dropzoneLockedTemplate; resume: RESUME_FEATURES.PROFILE_LOGO_MANAGE">
                <ng-container
                    [ngTemplateOutlet]="dropZone"
                    [ngTemplateOutletContext]="{ logoTarget: LOGO_TARGET.MAIN, logoSrc: mainLogo, dragKey: embedded() ? 'profile.company.drop_or_browse' : null }"
                />
            </ng-container>
            <ng-template
                #dropzoneLockedTemplate
                let-onLockedFeatureClick="onLockedFeatureClick"
            >
                <eb-blurred-content
                    [hasBlur]="false"
                    (click)="onLockedFeatureClick()"
                    onKeyDown
                >
                    <eb-blurred-content-body>
                        <ng-container
                            [ngTemplateOutlet]="simpleDropzonePreview"
                            [ngTemplateOutletContext]="{ logoSrc: mainLogo }"
                        />
                    </eb-blurred-content-body>
                    <eb-blurred-content-overlay class="profile-company__blurred-overlay">
                        <eb-icon
                            icon="ui/common/lock-closed"
                            width="40"
                        />
                    </eb-blurred-content-overlay>
                </eb-blurred-content>
            </ng-template>
        </div>
    </div>

    <div class="profile-company__logo profile-company__logo--secondary">
        <eb-label
            color="flat-secondary"
            size="sm"
            textTransform="uppercase"
            weight="black"
            >{{ (embedded() ? 'profile.company.secondary_logo_short' : 'profile.secondary_logo') | transloco }}</eb-label
        >
        <div class="mt-2 cursor-pointer">
            <ng-container *ebHasPermissions="[PERMISSIONS.PROFILE_LOGO_MANAGE]; else dropzoneSecondaryLockedTemplate; resume: RESUME_FEATURES.PROFILE_LOGO_MANAGE">
                <ng-container
                    [ngTemplateOutlet]="dropZone"
                    [ngTemplateOutletContext]="{
                        logoTarget: LOGO_TARGET.SECOND,
                        logoSrc: secondaryLogo,
                        isSquare: true,
                        dragKey: embedded() ? 'profile.company.square' : 'profile.drag_drop_files_short',
                    }"
                />
            </ng-container>
            <ng-template
                #dropzoneSecondaryLockedTemplate
                let-onLockedFeatureClick="onLockedFeatureClick"
            >
                <eb-blurred-content
                    [hasBlur]="false"
                    (click)="onLockedFeatureClick()"
                    onKeyDown
                >
                    <eb-blurred-content-body>
                        <ng-container
                            [ngTemplateOutlet]="simpleDropzonePreview"
                            [ngTemplateOutletContext]="{ logoSrc: secondaryLogo, isSquare: true }"
                        />
                    </eb-blurred-content-body>
                    <eb-blurred-content-overlay class="profile-company__blurred-overlay">
                        <eb-icon
                            icon="ui/common/lock-closed"
                            width="40"
                        />
                    </eb-blurred-content-overlay>
                </eb-blurred-content>
            </ng-template>
        </div>
    </div>
</div>

@if (!embedded()) {
    <ng-container *ebHasPermissions="[PERMISSIONS.PROFILE_LOGO_MANAGE]">
        <div class="mt-4 profile-company__actions">
            <eb-button-with-icon
                [disabled]="!canSave()"
                [iconButtonDisabledExplanation]="disabledExplanationKey() | transloco"
                [label]="'common.save_changes'"
                (buttonClick)="saveChanges()"
                icon="ui/action/symbols/save"
                iconWidth="16"
            >
                <eb-label
                    class="d-flex align-items-center p-1"
                    size="lg"
                >
                    {{ 'common.save_changes' | transloco }}
                </eb-label>
            </eb-button-with-icon>
        </div>
    </ng-container>
}

<ng-template
    #dropZone
    let-dragKey="dragKey"
    let-isSquare="isSquare"
    let-logoSrc="logoSrc"
    let-logoTarget="logoTarget"
>
    <ngx-dropzone
        class="profile-company__dropzone"
        [class.profile-company__dropzone--square]="isSquare"
        [multiple]="false"
        (change)="onSelectLogoByTarget($event, logoTarget)"
        accept="image/jpeg,image/jpg,image/png"
    >
        <ngx-dropzone-label class="profile-company__dropzone-label">
            <eb-label
                [innerHTML]="dragKey || 'profile.drag_drop_files' | transloco"
                [size]="isSquare ? 'md' : 'xl'"
                color="black"
            />
        </ngx-dropzone-label>
        @if (logoSrc) {
            <eb-dropzone-image-preview
                [file]="logoSrc"
                [removable]="true"
                (removed)="onRemoveLogoByTarget(logoTarget)"
                ngProjectAs="ngx-dropzone-preview"
            />
        }
    </ngx-dropzone>
</ng-template>

<ng-template
    #simpleDropzonePreview
    let-isSquare="isSquare"
    let-logoSrc="logoSrc"
>
    <ngx-dropzone
        class="profile-company__dropzone"
        [class.profile-company__dropzone--square]="isSquare"
        [disabled]="true"
    >
        @if (logoSrc) {
            <eb-dropzone-image-preview
                [file]="logoSrc"
                ngProjectAs="ngx-dropzone-preview"
            />
        }
    </ngx-dropzone>
</ng-template>
